<script>
  import Chart from '../chart/chart.svelte';
  import { createSortable } from '@dnd-kit/svelte/sortable';
  import Datatable from '../datatable/datatable.svelte';

  let {
    chart = {},
    portalChart = {},
    category = {},
    calculateFavourites = () => {},
    index,
  } = $props();

  const sortable = createSortable({
    get id() {
      return chart.id;
    },
    get index() {
      return index;
    },
  });

  let Component = $derived(chart?.config?.type === 'table' ? Datatable : Chart);
</script>

<div
  {@attach sortable.attach}
  class="grid-item"
  data-item-colspan={portalChart.colspan || 1}
  data-item-rowspan={portalChart.rowspan || 1}
>
  <!-- <button class="drag-handle" {@attach draggable.attachHandle}> Drag </button> -->
  <Component
    {...chart}
    id={portalChart.id}
    portal={portalChart}
    bind:dateRange={category.dateRange}
    refreshFavourites={() => calculateFavourites()}
  />
</div>
